module.exports = __webpack_public_path__ + "img/shinagawa.0b27554a.jpg";